import React, { FC } from 'react';
import { RootState, useSelector } from 'src/store';
import { changeEnterHTML } from 'src/utils/changeEnter';
import { getFontURL } from 'src/utils/getFontUrl';
import { trackingList } from 'src/utils/valueHTML';

const BottomSlideUpHTML: FC = () => {
  let bg = useSelector((state: RootState) => state.imageUpload.bg);
  let bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  let bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  let radius = useSelector((state: RootState) => state.imageUpload.radius);
  let deeplink = useSelector((state: RootState) => state.imageUpload.deeplink);
  let text = useSelector((state: RootState) => state.editText.text);
  let fontSize = useSelector((state: RootState) => state.editText.fontSize);
  let fontWeight = useSelector((state: RootState) => state.editText.fontWeight);
  let color = useSelector((state: RootState) => state.editText.color);
  let fontFamily = useSelector((state: RootState) => state.editText.fontFamily);
  let textAlign = useSelector((state: RootState) => state.editText.textAlign);
  let bgOpacity = useSelector(
    (state: RootState) => state.imageUpload.bgImageBlur
  );
  let tracking = useSelector((state: RootState) => state.trackings.tracking);
  let button1 = useSelector((state: RootState) => state.trackings.button1);
  let button2 = useSelector((state: RootState) => state.trackings.button2);
  let switchDarkMode = useSelector(
    (state: RootState) => state.switchButton.switchDarkMode
  );

  const titleFontURL = getFontURL(fontFamily?.title);

  const style = `
  
  	@font-face {
	font-family: 'title';
	src: url(${titleFontURL});
	}
	
	/* reset */
	* {
	  box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;
	}
	html,
	body {
		height: 100%;
		overflow: hidden;
	}
	main {
		height: 100%;
		position: relative;
	}
	a {
		color: #000000;
		cursor: pointer;
	}
	button {
		background: none;
		border: none;
	}

	/* custom */
	.root-view {
		width: 100%;
		height: 100%;
		position: relative;
		background: none;
		overflow: hidden;
	}
	.background {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		background: rgba(0, 0, 0, 0);
	}
	.slide-wrapper {
		width: 100%;
		height: 80px;
		position: absolute;		
		display: flex;
		justify-content: center;
		padding: 0 15px;		
		bottom: 63px;
	}
	.content-wrapper {
		display: flex;
		width: 100%;
		max-width: 480px;
		height: 100%;
		padding: 15px;			
		border: none;
		background: ${bgColor.background};
		border-radius:${radius.background}px;	
	}
	.image-wrapper {
		width: 50px;
		height: 50px;
		flex-shrink: 0;
	}
	.image {
		width: 100%;
		height: 100%;		
		border-radius:${radius?.logo}px;
	}
	.message-wrapper {
		width: 100%;
		height: 100%;		
		display: flex;
		align-items: center;		
		overflow: hidden;
    	white-space: normal;            
		text-overflow: ellipsis;
	}
	.message {
		width: 100%;  		
		font-size:  ${fontSize?.title}rem;
		font-family: ${
      ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
        fontFamily?.title
      )
        ? fontFamily?.title
        : 'title'
    };		
		font-weight: ${fontWeight?.title};
		text-align: ${textAlign?.title};
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		white-space: normal;		    	
		text-overflow: ellipsis;		
		line-height: 1.27;
		letter-spacing: -0.3px;
		margin-left: 10px;
		margin-right: 15px;
		color: ${color?.title};
	}
	.button-wrapper {
		height: 100%;
		display: flex;
		align-items: center;
	}

	.modal-slide-up {
		-webkit-animation: slideUp 0.2s ease-out forwards;
				animation: slideUp 0.2s ease-out forwards;
	}
	.ios-modal-slide-up {
		-webkit-animation: ios-slideUp 0.2s ease-out forwards;
				animation: ios-slideUp 0.2s ease-out forwards;
	}
	.modal-slide-down {
		-webkit-animation: slideDown 0.2s ease-out forwards;
				animation: slideDown 0.2s ease-out forwards;
	}
	.ios-modal-slide-down {
		-webkit-animation: ios-slideDown 0.2s ease-out forwards;
				animation: ios-slideDown 0.2s ease-out forwards;
	}

	@media (min-width: 599px) {
		.slide-wrapper {
			padding: 0px;
		}
		.content-wrapper {
			max-width: 480px;
		}
	}
	@-webkit-keyframes slideUp {
		from {
			bottom: -100px;
		}
		to {
			bottom: 63px;
		}
	}	
	@keyframes slideUp {
		from {
			bottom: -100px;
		}
		to {
			bottom: 63px;
		}
	}
	@-webkit-keyframes slideDown {
		from {
			bottom: 63px;
		}
		to {
			bottom: -100px;
		}
	}
	@keyframes slideDown {
		from {
			bottom: 63px;
		}
		to {
			bottom: -100px;
		}
	}
	@-webkit-keyframes ios-slideUp {
		from {
			bottom: -100px;
		}
		to {
			bottom: 96px;
		}
	}
	@keyframes ios-slideUp {
		from {
			bottom: -100px;
		}
		to {
			bottom: 96px;
		}
	}
	@-webkit-keyframes ios-slideDown {
		from {
			bottom: 96px;
		}
		to {
			bottom: -100px;
		}
	}
	@keyframes ios-slideDown {
		from {
			bottom: 96px;
		}
		to {
			bottom: -100px;
		}
	}	
	`;

  const html = `
    <div class="root-view">
		<div class="background"></div>
		<div id="modal" class="slide-wrapper">
			<div class="content-wrapper">
				<div class="image-wrapper">
					<img
						class="image"
						src="${bgImage?.logo}"
						alt="icon"
						decoding="async"
					/>
				</div>
				<div class="message-wrapper">
					<div class="message">
						${changeEnterHTML(text?.title)}
					</div>
				</div>
				<div class="button-wrapper">
					<div id="close-icon"></div>
				</div>
			</div>
		</div>
	</div>
  `;

  let tracking_list = `[`;
  for (let i = 0; i < tracking?.content?.length; i++) {
    tracking_list += `[\`${tracking?.content?.[i]}\`,\`${tracking?.close_button?.[i]}\`,\`${tracking?.background?.[i]}\`],`;
  }
  tracking_list += `]`;

  let tracking_button_list = trackingList('BOTTOM SLIDE UP', button1, button2);
  const js = `
   	document.addEventListener("DOMContentLoaded", function () {
		const modal = document.getElementById("modal");
		const closeIcon = document.getElementById("close-icon");
		const message = document.querySelector(".message");
		const contentWrapper = document.querySelector(".content-wrapper");
		const buttonWrapper = document.querySelector(".button-wrapper");
		const userAgent = navigator.userAgent.toLowerCase();

		const isIOS = /ipad|iphone|ipod|macintosh/.test(userAgent);
		const isDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;

		// modal slide up down animation 관리 함수
		function toggleModal(action) {
			modal.classList.remove("modal-slide-up", "ios-modal-slide-up", "modal-slide-down", "ios-modal-slide-down");
			modal.classList.add(action);
		} 

		// dark/light 모드에 따라 closeIcon의 설정을 위한 함수
		function setCloseIcon(rectFill, pathStroke, rectFillOpacity) {
			closeIcon.innerHTML = \`<svg width="22" height="22" viewBox="0 0 22 22"><rect width="22" height="22" rx="11" fill="\${rectFill}" fill-opacity="\${rectFillOpacity}" /><path d="M6.83325 6.83337L15.1666 15.1667" stroke="\${pathStroke}" stroke-width="1.2" stroke-linecap="round" /><path d="M15.1667 6.83337L6.83341 15.1667" stroke="\${pathStroke}" stroke-width="1.2" stroke-linecap="round" /></svg>\`;
		}
			
		// os에 따라 모달 transition 도착 위치 변경
		toggleModal(isIOS ? "ios-modal-slide-up" : "modal-slide-up");
		
		// 다크 모드에 따른 스타일 변경		
		if (${switchDarkMode} && isDarkMode) {
			contentWrapper.style.background = "#F1F2F3";
			message.style.color = "#222222";
			setCloseIcon("#000000", "#222222", "0.06"); 
		} else {
			setCloseIcon("white", "white", "0.24");
		}

		let tracking = ${tracking_list};
  		let button1 = ${tracking_button_list[0]};
  		let button2 = ${tracking_button_list[1]};

		document.querySelector(".content-wrapper").addEventListener("click", function (e) {			
			if (!buttonWrapper.contains(e.target)) {
				try {
					appboyBridge.logClick(tracking[0][0]);
					if (button1[0].indexOf(0) !== -1) {
						appboyBridge.logClick('0');
					}
					if (button2[0].indexOf(0) !== -1){
						appboyBridge.logClick('1');
					}
				} catch (err) {}
				window.location = "${deeplink?.content}";				
			}
		});
  		
		document.querySelector(".background").addEventListener("click", function () {
			try {
				appboyBridge.logClick(tracking[0][2]);
				if (button1[2].indexOf(0) !== -1) {
					appboyBridge.logClick('0');
				}
				if (button2[2].indexOf(0) !== -1) {
					appboyBridge.logClick('1');
				}
			} catch (err) {}

			if (isIOS) {
				toggleModal("ios-modal-slide-down");
			} else {
				toggleModal("modal-slide-down");
			}
			appboyBridge.closeMessage();
		});

		document.getElementById("close-icon").addEventListener("click", function () {
			event.stopPropagation();
			try {
				appboyBridge.logClick(tracking[0][1]);
				if (button1[1].indexOf(0) !== -1) {
					appboyBridge.logClick('0');
				}
				if (button2[1].indexOf(0) !== -1) {
					appboyBridge.logClick('1');
				}
			} catch (err) {}

			if (isIOS) {
				toggleModal("ios-modal-slide-down");
			} else {
				toggleModal("modal-slide-down");
			}
			appboyBridge.closeMessage();
		});
	});
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <meta
          http-equiv="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta http-equiv="Expires" content="0" />
        <meta http-equiv="Pragma" content="no-cache" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.css"
        />
        <style dangerouslySetInnerHTML={{ __html: style }}></style>
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }}></body>
      <script dangerouslySetInnerHTML={{ __html: js }}></script>
    </>
  );
};
export default BottomSlideUpHTML;
